import { actions } from '../actions/Goods';

const initialState = {
  index: {
    loading: false,
    data: [],
  },
};

const goodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.INDEX.REQUEST:
      return {
        ...state,
        index: {
          ...state.index,
          loading: true,
        },
      };
    case actions.INDEX.SUCCESS:
      return {
        ...state,
        index: {
          ...state.index,
          loading: false,
          data: action.payload,
        },
      };
    default:
      return state;
  }
};

export default goodsReducer;
